import { QueryClient } from '@tanstack/react-query';

// Дефолты на pilot — без агрессивного refetch, чтобы не нагружать API
// Serious при переключении страниц. Сводимо к тому, что у фронтендера,
// но без зависимости от их queries (у них свои).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
